import React from 'react';
import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

const SummarySection = muiStyled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  backgroundColor: '#fff',
  borderBottom: '1px solid #e0e0e0',
}));

const SplitViewContainer = muiStyled('div')({
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
  minHeight: 0,
});

const SidePanel = muiStyled(Box)(({ _theme }) => ({
  width: '30%',
  height: '100%',
  overflow: 'auto',
  borderRight: '1px solid #e0e0e0',
  backgroundColor: '#fff',
}));

const MainPanel = muiStyled(Box)(({ _theme }) => ({
  width: '70%',
  height: '100%',
  overflow: 'auto',
  backgroundColor: '#fff',
}));

const FullScreenLayout = ({
  header,
  summary,
  sidePanel,
  mainPanel,
  footer,
  showSplitView = false,
  sx = {}
}) => {
  return (
    <Box 
      sx={{ 
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        ...sx 
      }}
    >
      {/* Header Section */}
      {header && (
        <Box sx={{ mb: 2 }}>
          {header}
        </Box>
      )}

      {/* Summary Section (if provided) */}
      {summary && (
        <SummarySection>
          {summary}
        </SummarySection>
      )}

      {/* Main Content Area */}
      {showSplitView ? (
        <SplitViewContainer>
          <SidePanel>
            {sidePanel}
          </SidePanel>
          <MainPanel>
            {mainPanel}
          </MainPanel>
        </SplitViewContainer>
      ) : (
        <Box sx={{ flex: 1 }}>
          {mainPanel}
        </Box>
      )}

      {/* Footer Section */}
      {footer && (
        <Box display="flex" justifyContent="space-between" sx={{ mt: 2, pt: 2 }}>
          {footer}
        </Box>
      )}
    </Box>
  );
};

export default FullScreenLayout;
